import CryptoJS from "crypto-js";
// Get values securely from environment
const clientId = process.env.REACT_APP_CLIENT_ID;
if (!clientId) {
 console.error("REACT_APP_CLIENT_ID is missing in your .env file");
}
const key = CryptoJS.enc.Utf8.parse(clientId);
const iv = CryptoJS.enc.Utf8.parse(clientId.slice(-16));
export function encryptAES(plainText) {
 const encrypted = CryptoJS.AES.encrypt(
   CryptoJS.enc.Utf8.parse(plainText),
   key,
   {
     iv: iv,
     mode: CryptoJS.mode.CBC,
     padding: CryptoJS.pad.Pkcs7,
   }
 );
 return encrypted.toString(); // Base64 encoded
}
export function decryptAES(encryptedText) {
  const decrypted = CryptoJS.AES.decrypt(encryptedText, key, {
   iv: iv,
   mode: CryptoJS.mode.CBC,
   padding: CryptoJS.pad.Pkcs7,
 });

 return decrypted.toString(CryptoJS.enc.Utf8);
}